import { Skeleton } from "primereact/skeleton";
import { Tag } from "primereact/tag";

import S from "./_styles.module.scss";

export default function ExerciseLogs({ logs, isTestsRunning }) {
  if (isTestsRunning) {
    return (
      <div className="p-3">
        <Tag severity="info" className="mb-4" value="Running tests..."></Tag>
        <div className="flex flex-col gap-8">
          {[...Array(3)].map((_, idx) => (
            <div key={idx} className="flex flex-col gap-2">
              <Skeleton width="40%" />
              <Skeleton width="50%" />
              <Skeleton width="60%" />
              <Skeleton width="40%" />
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    logs && (
      <div className="p-3 atlas-code">
        {logs.status === "passed" ? (
          <Tag
            severity="success"
            icon="pi pi-check-circle"
            className="mb-4"
            value={logs.status.toUpperCase()}
          ></Tag>
        ) : (
          <Tag icon="pi pi-times-circle" className="mb-4" value={logs.status.toUpperCase()}></Tag>
        )}
        <pre
          className={S.logs}
          dangerouslySetInnerHTML={{
            __html: logs.results?.[0]?.output || "Error fetching test output",
          }}
        />
      </div>
    )
  );
}
